'use client';

import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { useBuyerNonSuspense } from '~/api/domains';

import { useTrack } from '~/hooks/event';

interface Props {
  page: string;
  properties?: Record<string, unknown>;
}

export function TrackPage({ page, properties }: Props) {
  const { track } = useTrack();
  const { data: user } = useBuyerNonSuspense();
  const searchParams = useSearchParams();

  const query = useMemo(() => {
    if (!searchParams) return {};

    const params: Record<string, string | string[]> = {};
    searchParams.forEach((value, key) => {
      const existing = params[key];
      if (existing) {
        params[key] = Array.isArray(existing)
          ? [...existing, value]
          : [existing, value];
      } else {
        params[key] = value;
      }
    });
    return params;
  }, [searchParams]);

  useEffect(() => {
    if (!user) return;
    track(`viewed ${page} page`, {
      ...properties,
      ...query,
      query,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return null;
}
